/**
 * String Utility.
 *
 * Abstracts common string operations.
 *
 */

/**
 * StringUtil Utility class.
 */
export default class StringUtil {
    /**
     * Enforces the string type on value
     * or return an empty string.
     *
     * @param {unknown} value
     * @return {String}
     */
    static enforce(value: unknown): string {
        if (typeof (value) !== 'string') {
            return '';
        }
        return value;
    }

    /**
     * Sanitize a string value to the ASCII character set.
     * (Codes 0-127)
     *
     * @param {unknown} target
     * @return {string}
     */
    static ascii(target: unknown) : string {
        let clean = '';
        const cleanTarget: string = StringUtil.enforce(target);
        for (let i = 0; i < cleanTarget.length; i++) {
            if (cleanTarget.charCodeAt(i) <= 127) {
                clean += cleanTarget[i];
            }
        }
        return clean;
    }
}
